export enum UserRole {
  ADMIN = 'admin',
  ARCHITECT = 'architect',
  CLIENT = 'client',
  VENDOR = 'vendor'
}

export enum VendorType {
  LABOUR = 'labour',
  MATERIAL = 'material'
}

export interface User {
  id: number;
  email: string;
  role: UserRole;
  vendorType?: VendorType;
  name: string;
  company?: string;
  phone?: string;
  isApproved: boolean;
  isActive: boolean;
  token?: string;
}

export interface LoginData {
  phone?: string;
  email?: string;
  password: string;
}

export interface RegisterData {
  name: string;
  phone?: string;
  email?: string;
  password: string;
  role: UserRole;
  vendorType?: VendorType;
  company?: string;
}
